import { render, staticRenderFns } from "./VSwiper.vue?vue&type=template&id=911f6892&scoped=true&"
import script from "./VSwiper.vue?vue&type=script&lang=js&"
export * from "./VSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VSwiper.vue?vue&type=style&index=0&id=911f6892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911f6892",
  null
  
)

export default component.exports